/**
 * Module 02 · Connect: whether an agent needs a reasoning model (routing v2).
 *
 * Stored on the agent as `llm.needs_reasoning`: a boolean, false by default.
 * With Auto model selection only reasoning-capable models are eligible; any
 * routed call with it on (Auto or pinned) lets a reasoning model think.
 *
 * React-free so the editor, the create wizard and the flow builder share it.
 */

export const NEEDS_REASONING_LABEL = 'Needs reasoning';

export const NEEDS_REASONING_HELP =
  'For steps that need multi-step logic or maths. Auto picks a reasoning model and lets it think; a pinned model is kept but allowed to think.';

/** A stored value as the switch position: only a literal true is on. */
export function needsReasoningFromStored(v: unknown): boolean {
  return v === true;
}

/** The switch position as stored on `llm.needs_reasoning` (always a boolean). */
export function needsReasoningToStored(v: boolean | null | undefined): boolean {
  return v === true;
}
